import auditStyles from './audit/relay.module.css';
import broadcastStyles from './broadcast/relay.module.css';

import {isAudit} from "../../helpers/relay";

export default isAudit() ? auditStyles : broadcastStyles;
